import React, { useCallback, useMemo, useRef } from 'react';
import Filter from '@/pages/dashboard/components/NewFilter';
import { FORM_MAP } from '@/pages/dashboard/pages/overview/_config/constant';
import { setBtnPointLog } from '@/pages/dashboard/utils/utils';
import { useSelector } from 'umi';
import {
  InputItemType,
  filterValueType,
} from '../../components/NewFilter/_type';
import { useInputList, useNoVisibleValue } from '../common/hooks';
import { useFilterData } from '../monetization/hooks';
import { DEFAULT_SELECTOR } from '../common/const';
import moment from 'moment';
import { resolveDashboardSelectorFilters } from '../common/pageSelectorUtils';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

// daily筛选器继承逻辑
const RealtimeSteamSalesFilter = (props: any) => {
  const {
    filterConfirm,
    filterReset,
    filterInit,
    buttonLogConfig,
    openSticky = false,
    path,
    children,
    isHaveFilterSave,
    timeZone = 0,
  } = props;
  // 筛选器值，此处不用state，更新formValue同样会触发组件更新
  const filterValueRef = useRef<any>(null);
  const { gameConfig } = useSelector((state: any) => ({
    // 初始可能为undefied,在此加兜底
    gameConfig: state.dashboardSetting.gameConfig,
  }));

  const defaultSelect = useMemo(
    () => resolveDashboardSelectorFilters(gameConfig, path),
    [gameConfig, path],
  );

  // 前段配置兜底筛选器
  const defaultSelectorList = useMemo(() => {
    const defaultFilter = ['region', 'category'];
    // 固定默认筛选器
    return DEFAULT_SELECTOR.map((item) => {
      if (!defaultFilter.includes(item.key)) {
        return {
          ...item,
          visible: 0
        };
      }
      return item;
    }
    );
  }, []);

  const { loading, selector } = useFilterData(path, defaultSelectorList);
  const { latestDate } = selector || {};

  // 设置兜底筛选器
  const defaultInputList = [
    {
      type: 'singleDaily',
      key: 'singleDaily',
      default: moment().utcOffset(timeZone).format('YYYY-MM-DD'), // 根据时区设置默认值
    },
    {
      type: 'contrastDaily',
      key: 'contrastDaily',
      default: moment().utcOffset(timeZone).subtract(7, 'day').format('YYYY-MM-DD'),
    },
    ...defaultSelectorList,
  ];

  // 获取筛选器
  const inputList = useInputList({
    loading,
    pageSelector: defaultSelect || [],
    defaultSelector: defaultInputList,
  });

  // 获取未展示的值
  const noVisibleValues = useNoVisibleValue(defaultSelect || defaultSelectorList);

  // 私有化处理，抹平新旧筛选器的差距
  const onInit = useCallback(
    (
      value: filterValueType,
      inputList: Array<InputItemType>,
      isHaveExtendFIlter: boolean,
    ) => {
      filterValueRef.current = value;
      // todo 锁定状态下如果锁定时间跟默认时间相同，是否需要单独处理，设置diff为false？
      filterInit({
        ...(value || {}),
        ...noVisibleValues,
        [FORM_MAP.RANGE_TIME_DIFF]: !isHaveExtendFIlter,
        timeType: 'Day',
        selector,
        filterDefaultSelect: defaultSelectorList
      });
    },
    [filterInit],
  );
  
  const onConfirm = useCallback(
    (value: filterValueType) => {
      filterValueRef.current = value;
      const obj: any = {
        ...(value || {}),
        ...noVisibleValues,
        [FORM_MAP.RANGE_TIME_DIFF]: false,
        timeType: 'Day',
      };
      filterConfirm(obj);
      // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
      setBtnPointLog(buttonLogConfig, value);
    },
    [filterConfirm, buttonLogConfig],
  );

  const onReset = useCallback(
    (value: filterValueType) => {
      filterValueRef.current = value;
      const obj = {
        ...(value || {}),
        ...noVisibleValues,
        [FORM_MAP.RANGE_TIME_DIFF]: true,
        timeType: 'Day',
      };
      filterReset(obj);
      // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
      setBtnPointLog(buttonLogConfig, value, true);
    },
    [filterReset, buttonLogConfig],
  );
  return (
    <Filter
      openSticky={openSticky}
      path={path}
      isHaveFilterSave={isHaveFilterSave}
      outLatestDate={latestDate}
      value={filterValueRef.current}
      latestDateType={''}
      inputList={inputList}
      onInit={onInit}
      onConfirm={onConfirm}
      onReset={onReset}
      loading={loading}
      useOutInput={true}
      outSelector={selector}
    >
      {children}
    </Filter>
  );
};

export default RealtimeSteamSalesFilter;
